import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CleaningsService {

  constructor(
    private http: HttpClient
  ) { }

  getCleanings() {
    return (this.http.get(`${environment.apiUrl}/cleanings`));
  }

  createCleaning(data: any) {
    return (this.http.post(`${environment.apiUrl}/cleanings`, data));
  }

  getCleaningById(id: number) {
    return (this.http.get(`${environment.apiUrl}/cleanings/${id}`));
  }

  updateCleaning(data: any) {
    return (this.http.put(`${environment.apiUrl}/cleanings/${data.id}`, data));
  }

  deleteCleaning(id: number) {
    return (this.http.delete(`${environment.apiUrl}/cleanings/${id}`));
  }
}
